const contractNames = { PRIMARY: '파주', SECONDARY: '서울' };

/** Use only the server's approval-contract classification; never infer from a PG service ID. */
export function adminPaymentContractLabel(item) {
  const keyFields = ['contractKey', 'contract_key', 'contractId', 'contract_id'];
  // An explicit UNMAPPED classification must remain visible even if another
  // alias is null. Otherwise an explicit null key means no contract applies;
  // a stale name alone must not manufacture one.
  if (keyFields.some((field) => typeof item?.[field] === 'string' && item[field].trim().toUpperCase() === 'UNMAPPED')) {
    return '계약 정보 확인 필요';
  }
  if (keyFields.some((field) => item?.[field] === null)) return '-';
  const rawKey = item?.contractKey ?? item?.contract_key ?? item?.contractId ?? item?.contract_id;
  const rawName = item?.contractName ?? item?.contract_name;
  const key = typeof rawKey === 'string' ? rawKey.trim().toUpperCase() : '';
  const name = typeof rawName === 'string' ? rawName.trim() : '';

  if (rawKey != null && typeof rawKey !== 'string') return '확인 필요';
  if (!key && !name) return '-';
  // UNMAPPED is an exception requiring review, not a third contract.
  if (key === 'UNMAPPED' || (!key && name === '미분류')) return '계약 정보 확인 필요';
  if (key) {
    const expectedName = contractNames[key];
    if (!expectedName || (name && name !== expectedName)) return '확인 필요';
    return expectedName;
  }
  return Object.values(contractNames).includes(name) ? name : '확인 필요';
}
